export const isCheckboxSelected = (selectedOption, options) =>
  options.findIndex((option) => option.id === selectedOption.id) >= 0;

export const isHeaterDisabled = (option, size) => {
  return false
};

// TODO: rewrite ids to names for easier to read logic that is prone to changes
export const isUpgradeDisabled = (option, heater) => {
  switch (option.id) {
    case 1:
      return heater?.id === 1 || heater?.id === 3 || heater?.id === 4;
    case 2:
      return heater?.id === 1 || heater?.id === 3 || heater?.id === 4;
    case 3:
      return heater?.id === 1 || heater?.id === 3 || heater?.id === 4;
    case 4:
      return heater?.id === 3 || heater?.id === 4;
    default:
      return false;
  }
};

export const hasWrongLid = (lidCover, heater, heaterUpgrades) => {
  const electricHeater = heater?.id === 3;
  const electricHeaterUpgrade = heaterUpgrades?.find(upgrade => upgrade.id === 4)
  return lidCover && lidCover.id === 1 && (electricHeater || electricHeaterUpgrade)
}

export const wrongSizeLidSelected = (lidCover, size) => {
  return size && size.id !== 3
}

export const isLinerDisabled = (option, wood) => {
  switch (option?.id) {
    case 1:
      return wood?.id === 3 || wood?.id === 4;
    default:
      return false;
  }
};

export const isLinerColorDisabled = (liner, size) =>
  size?.id !== 3 && liner.length === 0;

export const isSeatingDisabled = (liner, option, wood) =>
    (option?.id !== 1 && liner.length === 0)

export const isLidCoverDisabled = (option, size, heater, upgrades) => {
  switch (option?.id) {
    case 1:
      return hasWrongLid(option, heater, upgrades)
    case 2:
      return size?.id !== 3;
    default:
      return false;
  }
};

export const isWoodDisabled = (option, liner, size) => {
  switch (option?.id) {
    case 3:
    case 4:
      return (size?.id !== 3 && liner.length === 0);
    default:
      return false;
  }
};

export const isFlueDrainDisabled = (option, heater) => {
  switch (option?.id) {
    case 1:
    case 3:
      return heater?.id === 1 || heater?.id === 3;
    default:
      return false;
  }
};

export const isElectricalDisabled = (option, electrical, liner, size) => {
  switch (option.id) {
    case 2:
      return (
        (size?.id !== 3 && liner.length === 0) ||
        electrical.findIndex((item) => item.id === 4) >= 0 ||
        electrical.findIndex((item) => item.id === 3) >= 0
      );
    case 3:
      return (
        electrical.findIndex((item) => item.id === 2) >= 0
      );
    case 4:
      return (
        (size?.id !== 3 && liner.length === 0) ||
        electrical.findIndex((item) => item.id === 2) >= 0
      );
    default:
      return false;
  }
};

export const isWoodenDisabled = (option, liner, lidCover, size) => {
  switch (option?.id) {
    case 3:
      return (size?.id !== 3 && liner.length === 0) || lidCover?.id !== 1;
    case 6:
      return (size?.id === 3) || liner.length > 0
    default:
      return false;
  }
};

export const isElectricalVariantDisabled = (variant, option, electrical) => {
  if (variant?.id === 2 && option?.id === 3) {
    return electrical.findIndex((item) => item.id === 2) >= 0;
  }
  return false;
};

export const isWaterCareDisabled = (option, waterCare) => {
  switch (option?.id) {
    case 1:
      return waterCare.findIndex((item) => item.id === 3) >= 0;
    case 2:
      return waterCare.findIndex((item) => item.id === 1) < 0;
    case 3:
      return waterCare.findIndex((item) => item.id === 1) >= 0;
    default:
      return false;
  }
};

export const isSubmitDisabled =
  (size, heaters, interiorexterior) => (currentSection) => {
    switch (currentSection) {
      case "sizes":
        return !size?.id;
      case "heaters":
        return !heaters.heater?.id;
      case "interiorexterior":
        return (
          !interiorexterior.wood ||
          (interiorexterior.liner.length === 0
            ? false
            : !interiorexterior.linerColor) ||
          (size?.id === 3 && !interiorexterior.linerColor) ||
          !interiorexterior.lidCover
        );
      default:
        return false;
    }
  };
